module.exports = __webpack_public_path__ + "static/media/terminate.7030e833.svg";